
const checkLocalStorage = () => {
    try {
        return localStorage &&
            typeof localStorage !== 'undefined'
    } catch (error) {
        return false;
    }
}

function localStorageHelper() {
    this.check = checkLocalStorage();

    this.set = (key, value) => this.check &&
        localStorage.setItem(key, value);
    
    this.get = (key) => this.check &&
        localStorage.getItem(key)
    
    this.remove = (key) => this.check &&
        localStorage.removeItem(key)
}

export default new localStorageHelper();
